/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M480 0c17.597 0 32 14.405 32 32v448c0 17.592-14.402 32-32 32H323.865V308.343h86.963v-85.801h-86.963v-44.063c-.83-15.413 8.423-26.532 16.244-26.678h70.72V66h-70.72c-57.61 0-104.866 50.576-104.369 112.48v44.062H165v85.801h70.74V512H32C14.583 512 .288 497.879.004 480.526L0 480V32C0 14.405 14.407 0 32 0z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconFacebook = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconFacebook.defaultProps = {
  theme,
};
IconFacebook.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconFacebook.displayName = 'IconFacebook';
export { IconFacebook };
